import {
  FETCHING_DEALS_REQUEST,
  FETCHING_DEALS_FAILED,
  FETCHING_DEALS_SUCCEEDED,
  FETCHING_DEALS_METRICS_REQUEST,
  FETCHING_DEALS_METRICS_SUCCEEDED,
  FETCHING_DEALS_METRICS_FAILED,
  FETCHING_DEAL_HISTORY_REQUEST,
  FETCHING_DEAL_HISTORY_SUCCEEDED,
  FETCHING_DEAL_HISTORY_FAILED,
  FETCHING_DEAL_TIMELINE_REQUEST,
  FETCHING_DEAL_TIMELINE_SUCCEEDED,
  FETCHING_DEAL_TIMELINE_FAILED,
  FETCHING_DEAL_SHARED_ASSETS_REQUEST,
  FETCHING_DEAL_SHARED_ASSETS_SUCCEEDED,
  FETCHING_DEAL_SHARED_ASSETS_FAILED,
  FETCHING_DEAL_SHARED_COLLECTIONS_REQUEST,
  FETCHING_DEAL_SHARED_COLLECTIONS_SUCCEEDED,
  FETCHING_DEAL_SHARED_COLLECTIONS_FAILED,
  FETCHING_DEAL_INSIGHTS_SIGNALS,
  FETCHING_DEAL_INSIGHTS_SIGNALS_SUCCEEDED,
  FETCHING_DEAL_INSIGHTS_SIGNALS_FAILED,
  INVALIDATE_DEAL_INSIGHTS,
  FETCHING_DEAL_REQUEST,
  FETCHING_DEAL_SUCCEEDED,
  FETCHING_DEAL_FAILED,
  INVALIDATE_DEAL
} from "../actions/actionTypes.jsx";

import _ from "lodash";

const initialState = {
  allDeals: [],
  fetching: false,
  currentPage: 0,
  totalPages: 0,
  totalRecordsCount: 0,
  metrics: {
    fetching: false,
    success: false,
    error: null,
    data: {
      count: 0,
      value: 0,
      confidence: 0
    }
  },
  history: {
    fetching: false,
    success: false,
    error: null,
    items: [],
    currentPage: 0,
    totalPages: 0,
    totalRecordsCount: 0,
  },
  timeline: {
    fetching: false,
    success: false,
    error: null,
    items: [],
    currentPage: 0,
    totalPages: 0,
    totalRecordsCount: 0,
  },
  sharedAssets: {
    fetching: false,
    success: false,
    error: null,
    items: [],
    currentPage: 0,
    totalPages: 0,
    totalRecordsCount: 0,
  },
  sharedCollections: {
    fetching: false,
    success: false,
    error: null,
    items: [],
    currentPage: 0,
    totalPages: 0,
    totalRecordsCount: 0,
  }

};

function dealInsightsReducer(state = initialState, action) {
  switch (action.type) {
    case FETCHING_DEALS_REQUEST:
      return {
        ...state,
        fetching: true,
      };

    case FETCHING_DEALS_SUCCEEDED:
      var deals = []
      if (action.payload.currentPage === 0) {
        deals = action.payload.records
      }
      else {
        deals = [...state.allDeals, ...action.payload.records]
      }

      return {
        ...state,
        currentPage: action.payload.currentPage,
        totalPages: action.payload.totalPages,
        totalRecordsCount: action.payload.totalRecordsCount,
        fetching: false,
        allDeals: deals
      };

    case FETCHING_DEALS_FAILED:
      return {
        ...state,
        error: action.payload.error,
        fetching: false,
      };

    case FETCHING_DEALS_METRICS_REQUEST:
      return {
        ...state,
        metrics: {
          ...state.metrics,
          fetching: true
        }
      }

    case FETCHING_DEALS_METRICS_SUCCEEDED:
      return {
        ...state,
        metrics: {
          fetching: false,
          success: true,
          error: null,
          data: action.payload
        }
      }
    case FETCHING_DEALS_METRICS_FAILED:
      return {
        ...state,
        metrics: {
          fetching: false,
          success: false,
          error: action.payload,
          data: {
            count: 0,
            value: 0,
            confidence: 0
          }
        }
      }

    case FETCHING_DEAL_HISTORY_REQUEST:
      return {
        ...state,
        history: {
          fetching: true,
          success: false,
          error: null,
          items: [],
          currentPage: 0,
          totalPages: 0,
          totalRecordsCount: 0,
        }
      }

    case FETCHING_DEAL_HISTORY_SUCCEEDED:
      return {
        ...state,
        history: {
          fetching: false,
          success: true,
          error: null,
          items: action.payload.records,
          currentPage: action.payload.currentPage,
          totalPages: action.payload.totalPages,
          totalRecordsCount: action.payload.totalRecordsCount,
        }
      }

    case FETCHING_DEAL_HISTORY_FAILED:
      return {
        ...state,
        history: {
          fetching: false,
          success: false,
          error: action.payload,
          items: [],
          currentPage: 0,
          totalPages: 0,
          totalRecordsCount: 0,
        }
      }

    case FETCHING_DEAL_TIMELINE_REQUEST: {

      var timeline = state.timeline;
      if (action.payload.page === 0) {

        timeline = {
          fetching: true,
          success: false,
          error: null,
          items: [],
          currentPage: 0,
          totalPages: 0,
          totalRecordsCount: 0,
        }
      }

      return {
        ...state,
        timeline: timeline
      }
    }


    case FETCHING_DEAL_TIMELINE_SUCCEEDED: {
      var timeline = []
      if (action.payload.currentPage === 0) {
        timeline = action.payload.records
      }
      else {
        timeline = [...state.timeline.items, ...action.payload.records]
      }

      return {
        ...state,
        timeline: {
          fetching: false,
          success: true,
          error: null,
          items: timeline,
          currentPage: action.payload.currentPage,
          totalPages: action.payload.totalPages,
          totalRecordsCount: action.payload.totalRecordsCount,
        }
      }
    }


    case FETCHING_DEAL_TIMELINE_FAILED:
      return {
        ...state,
        timeline: {
          fetching: false,
          success: false,
          error: action.payload,
          items: [],
          currentPage: 0,
          totalPages: 0,
          totalRecordsCount: 0,
        }
      }

    case FETCHING_DEAL_SHARED_ASSETS_REQUEST:
      return {
        ...state,
        sharedAssets: {
          ...state.sharedAssets,
          fetching: true,
          success: false,
          error: null,
        }
      }

    case FETCHING_DEAL_SHARED_ASSETS_SUCCEEDED:

      const currentPage = _.get(action, "payload.currentPage", 0);
      var items = []
      if(currentPage === 0){
        items = _.get(action, "payload.records", [])
      }
      else{
        items = [..._.get(state, `sharedAssets.items`, []), ..._.get(action, "payload.records", [])]
      }
        

      return {
        ...state,
        sharedAssets: {
          fetching: false,
          success: true,
          error: null,
          items,
          currentPage: _.get(action,"payload.currentPage"),
          totalPages: _.get(action,"payload.totalPages"),
          totalRecordsCount: _.get(action,"payload.totalRecordsCount")
        }
      }

    case FETCHING_DEAL_SHARED_ASSETS_FAILED:
      return {
        ...state,
        sharedAssets: {
          fetching: false,
          success: false,
          error: action.payload,
          items: [],
          currentPage: _.get(state,"sharedAssets.currentPage"),
          totalPages: _.get(state,"sharedAssets.totalPages"),
          totalRecordsCount: _.get(state,"sharedAssets.totalRecordsCount")
        }
      }

    case FETCHING_DEAL_SHARED_COLLECTIONS_REQUEST:
      return {
        ...state,
        sharedCollections: {
          fetching: true,
          success: false,
          error: null,
          items: []
        }
      }

    case FETCHING_DEAL_SHARED_COLLECTIONS_SUCCEEDED:
      return {
        ...state,
        sharedCollections: {
          fetching: false,
          success: true,
          error: null,
          items: action.payload
        }
      }

    case FETCHING_DEAL_SHARED_COLLECTIONS_FAILED:
      return {
        ...state,
        sharedCollections: {
          fetching: false,
          success: false,
          error: action.payload,
          items: []
        }
      }

    case FETCHING_DEAL_INSIGHTS_SIGNALS:

    const page = _.get(action, "payload.page", 0)

      return {
        ...state,
        signals: {
           ...state.signals,
          fetching: true,
          error: null,
          items: page === 0 ? [] : _.get(state, `signals.items`, []),
        }
      }

    case FETCHING_DEAL_INSIGHTS_SIGNALS_SUCCEEDED:

    var items = []
    if (_.get(action,"payload.data.currentPage") === 0) {
      items = _.get(action,"payload.data.records",[])
    }
    else {
      items = [..._.get(state, `signals.items`, []), ..._.get(action,"payload.data.records",[])]
    }

      return {
        ...state,
        signals: { 
            fetching: false,
            error: null,
            currentPage: _.get(action,"payload.data.currentPage"),
            totalPages: _.get(action,"payload.data.totalPages"),
            totalRecordsCount: _.get(action,"payload.data.totalRecordsCount"),
            items
          } 
      }

    case FETCHING_DEAL_INSIGHTS_SIGNALS_FAILED:
      return {
        ...state,
        signals: {
            ..._.get(state, `signals`),
            fetching: false,
            error: action.payload.error,
          } 
      }
  
    case FETCHING_DEAL_REQUEST:

      return Object.assign({}, state, {
        ...state,
        currentDeal:{
          fetching: true,
          item: null,
          error: null
        }
      })

    case FETCHING_DEAL_SUCCEEDED:
      return Object.assign({}, state, {
        ...state,
        currentDeal:{
          fetching: false,
          item: action.payload,
          error: null
        }
      })

    case FETCHING_DEAL_FAILED:
      return Object.assign({}, state, {
        ...state,
        currentDeal:{
          fetching: false,
          item: null,
          error: action.payload
        }
      })

    case INVALIDATE_DEAL:
      return Object.assign({}, state, {
        ...state,
        currentDeal: {
          fetching: false,
          item: null,
          error: null
        }
      })

    case INVALIDATE_DEAL_INSIGHTS:
      return {
        initialState
      }

    default:
      return state;
  }
}

export { dealInsightsReducer };
